var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30,
    fill: "#4E12BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8955 29.4735C40.8955 35.1785 36.7538 40.5218 31.0955 42.0852C30.7105 42.1902 30.2905 42.1902 29.9055 42.0852C24.2471 40.5218 20.1055 35.1785 20.1055 29.4735V24.3518C20.1055 23.3952 20.8288 22.3102 21.7272 21.9485L28.2255 19.2885C29.6838 18.6935 31.3288 18.6935 32.7871 19.2885L39.2855 21.9485C40.1721 22.3102 40.9072 23.3952 40.9072 24.3518L40.8955 29.4735Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4993 31.0832C31.788 31.0832 32.8327 30.0385 32.8327 28.7498C32.8327 27.4612 31.788 26.4165 30.4993 26.4165C29.2107 26.4165 28.166 27.4612 28.166 28.7498C28.166 30.0385 29.2107 31.0832 30.4993 31.0832Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 31.083V34.583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.1a4cc52e20bbbd1e2d30a16639d1adb8.svg";
export { ForwardRef as ReactComponent };